module.exports = __webpack_public_path__ + "static/media/1@3x.8008a296.png";